module.exports = __webpack_public_path__ + "media/images/flags/32/France-e375af015f8e1e921588c608629610e6.png";